import { useState } from "react";
import {
  ShieldCheck,
  Truck,
  MapPin,
  ChevronDown,
  ChevronUp,
  Building2,
  Package,
} from "lucide-react";

const STEPS = [
  {
    icon: Package,
    label: "Sourced & Verified",
    detail: "Product sourced from trusted global marketplace",
    color: "text-blue-500",
    bg: "bg-blue-50",
  },
  {
    icon: Truck,
    label: "Direct via FedEx",
    detail: "No freight-forwarder middlemen. FedEx door-to-hub.",
    color: "text-orange-500",
    bg: "bg-orange-50",
  },
  {
    icon: Building2,
    label: "Inspected at DHC HQ",
    detail: "Quality check at Culloden Road, BB14018",
    color: "text-violet-500",
    bg: "bg-violet-50",
  },
  {
    icon: MapPin,
    label: "Delivered to You",
    detail: "Collect at HQ or parish-based private delivery",
    color: "text-emerald-500",
    bg: "bg-emerald-50",
  },
];

export default function LogisticsTransparency({ className = "" }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`border border-slate-200 rounded-lg overflow-hidden ${className}`}>
      <div className="bg-gradient-to-r from-slate-900 to-slate-800 px-5 py-3 flex items-center gap-3">
        <ShieldCheck className="h-5 w-5 text-emerald-400 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white">Logistics Transparency</p>
          <p className="text-xs text-slate-400">
            No freight-forwarder middlemen. Direct via FedEx to DHC HQ.
          </p>
        </div>
        <span className="bg-emerald-500/20 text-emerald-400 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full whitespace-nowrap">
          Landed Price Guarantee
        </span>
      </div>

      <div className="px-5 py-4 grid grid-cols-2 sm:grid-cols-4 gap-3">
        {STEPS.map((step, i) => (
          <div key={i} className="flex items-start gap-2">
            <div className={`p-1.5 rounded-lg ${step.bg} flex-shrink-0`}>
              <step.icon className={`h-4 w-4 ${step.color}`} />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold text-slate-800">{step.label}</p>
              <p className="text-[11px] text-slate-500 leading-tight">{step.detail}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="border-t border-slate-100">
        <button
          onClick={() => setExpanded((open) => !open)}
          className="w-full flex items-center justify-between px-5 py-3 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors"
        >
          <span>What&apos;s included in your delivered price</span>
          {expanded ? (
            <ChevronUp className="h-4 w-4 text-slate-400" />
          ) : (
            <ChevronDown className="h-4 w-4 text-slate-400" />
          )}
        </button>

        {expanded && (
          <div className="px-5 pb-5 space-y-2 text-sm text-slate-600">
            <p>Your checkout price is all-inclusive — no surprise invoices at customs.</p>
            <ul className="list-disc pl-5 space-y-1 text-xs text-slate-500">
              <li>International freight from supplier to Caribbean hub</li>
              <li>Import duties, taxes, and clearance processing</li>
              <li>White-glove inspection and secure repackaging</li>
              <li>Final-mile delivery or HQ collection</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
